import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

const TokenOrderDetails = ({
  containtedQty,
  unitOfMeasure,
  productPrice,
  quantity,
  totalSelectedContainedQty,
  totalAmountWithoutTax,
  productTax,
  total,
  onContainedQtyChange
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="card">
      <div className="card-header">
        <div className="card-title">{t("Order Details")}</div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="containtedQty">
            {t("Contained Quantity")}
          </label>
          <input
            type="number"
            className="form-control"
            id="containtedQty"
            name="containtedQty"
            min={1}
            value={containtedQty}
            onChange={onContainedQtyChange}
          />
        </div>
        <div className="form-group">
          <label className="form-label">{t("Unit of Measure")}</label>
          <input type="text" className="form-control" value={unitOfMeasure || "-"} readOnly />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="productPrice">
            {t("Product Price ($)")}
          </label>
          <input
            type="text"
            className="form-control"
            id="productPrice"
            name="productPrice"
            value={productPrice}
            readOnly
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="tokenQty">
            {t("Add Token Quantity")}
          </label>
          <input
            type="text"
            className="form-control"
            id="tokenQty"
            name="tokenQty"
            value={quantity ?? ""}
            readOnly
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label className="form-label" htmlFor="totalSelectedContainedQty">
            {t("Total Selected Quantity")}
          </label>
          <input
            type="text"
            className="form-control"
            id="totalSelectedContainedQty"
            name="totalSelectedContainedQty"
            value={totalSelectedContainedQty}
            readOnly
          />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="totalAmountWithoutTax">
            {t("Sub Total ($)")}
          </label>
          <input
            type="text"
            className="form-control"
            id="totalAmountWithoutTax"
            name="totalAmountWithoutTax"
            value={totalAmountWithoutTax}
            readOnly
          />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label" htmlFor="productTax">
          {t("Tax Amount ($)")}
        </label>
        <input
          type="text"
          className="form-control"
          id="productTax"
          name="productTax"
          value={productTax}
          readOnly
        />
      </div>
      <div className="token-total-box">
        <div className="token-total-box-header">
          <span className="token-total-box-label">{t("Total Amount ($)")}</span>
          <span className="token-total-box-incl">{t("Including all taxes")}</span>
        </div>
        <div className="token-total-box-value">${total}</div>
      </div>
    </div>
  );
};

TokenOrderDetails.propTypes = {
  containtedQty: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  unitOfMeasure: PropTypes.string,
  productPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  totalSelectedContainedQty: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  totalAmountWithoutTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  productTax: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onContainedQtyChange: PropTypes.func.isRequired
};

TokenOrderDetails.defaultProps = {
  unitOfMeasure: ""
};

export default TokenOrderDetails;
